/**
 * url_weixin
 */
var url_wx = (window.location.hostname == 'devtest.souche.com')? '//weixin.sqaproxy.souche.com': '//wx.souche.com';
$(function () {
	var getJsapiSignature = $.ajax({
		url: url_wx + '/getJsapiSignature.jsonp',
		type: 'GET',
		dataType: 'jsonp',
		data: {
			siteId: window._qiwa && window._qiwa.__site_basic && window._qiwa.__site_basic.siteId,
			url: location.href
		}
	});

	$.when(getJsapiSignature).then(function (data) {
		var share_data = data;
		share_data.data.debug = false;
		share_data.data.jsApiList = ['onMenuShareAppMessage','onMenuShareTimeline'];
		wx.config(share_data.data);
		wx.error(function (res) {
			if (res.errMsg == 'config:require subscribe') {
				// $('body').hide();
				// alert('您没有关注本公众号');
			} else {
				// alert(res.errMsg);
			}
		});
		wx.ready(function() {
			var $content_ad = $('.content-ad');
			var desc = $content_ad.length? $content_ad.text(): window.location.hostname;
			var link = window.location.href;
			var title = $("title").text();
			var imgUrl = 'http:' + $("img").eq(0).attr('src');
			wx.onMenuShareAppMessage({
				title: title,
				desc: desc,
				link: link,
				imgUrl: imgUrl,
				fail: function(res) {
					alert(JSON.stringify(res));
				}
			});
			wx.onMenuShareTimeline({
				title: title,
				desc: desc,
				link: link,
				imgUrl: imgUrl,
				fail: function(res) {
					alert(JSON.stringify(res));
				}
			});
		});
	});
});



//////////////////
// WEBPACK FOOTER
// ./~/@souche-f2e/chunyan-util/qiwa-common_m/lib/share_wx.js
// module id = 279
// module chunks = 4